import React, { useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import SidebarNav from './sidebar-nav.jsx';
import { useLocation } from "react-router-dom";

function Sidebar() {
	const { pathname } = useLocation();
	
	useEffect(() => {
		const body = document.querySelector('body');
		body.classList.add('app-init', 'theme-gray-500');

		const handleSidebarMenuToggle = (menus) => {
			menus.map((menu) => {
				menu.onclick = function (e) {
					e.preventDefault();
					const target = this.nextElementSibling;

					menus.map((m) => {
						const otherTarget = m.nextElementSibling;
						if (otherTarget !== target) {
							otherTarget.style.display = 'none';
							otherTarget.closest('.menu-item').classList.remove('expand');
						}
						return true;
					});

					const targetItemElm = target.closest('.menu-item');

					if (
						targetItemElm.classList.contains('expand') ||
						(targetItemElm.classList.contains('active') && !target.style.display)
					) {
						targetItemElm.classList.remove('expand');
						target.style.display = 'none';
					} else {
						targetItemElm.classList.add('expand');
						target.style.display = 'block';
					}
				};
				return true;
			});
		};

		const menuBaseSelector = '.app-sidebar .menu > .menu-item.has-sub';
		const submenuBaseSelector = ' > .menu-submenu > .menu-item.has-sub';

		// menu
		const menuLinkSelector = menuBaseSelector + ' > .menu-link';
		const menus = [].slice.call(document.querySelectorAll(menuLinkSelector));
		handleSidebarMenuToggle(menus);

		// submenu lvl 1
		const submenuLvl1Selector = menuBaseSelector + submenuBaseSelector;
		const submenusLvl1 = [].slice.call(document.querySelectorAll(submenuLvl1Selector + ' > .menu-link'));
		handleSidebarMenuToggle(submenusLvl1);

		// submenu lvl 2
		const submenuLvl2Selector = menuBaseSelector + submenuBaseSelector + submenuBaseSelector;
		const submenusLvl2 = [].slice.call(document.querySelectorAll(submenuLvl2Selector + ' > .menu-link'));
		handleSidebarMenuToggle(submenusLvl2);

		// limpieza al desmontar
		return () => {
			body.classList.remove('app-init', 'theme-gray-500');
		};
	}, []);

	const toggleAppSidebarMobile = () => {
		const elm = document.querySelector('.app');
		elm.classList.toggle('app-sidebar-mobile-toggled');
	};

	return (
		<React.Fragment>
			<div id="sidebar" className="app-sidebar">
				<PerfectScrollbar className="app-sidebar-content" options={{ suppressScrollX: true }}>
					<SidebarNav />
			
				</PerfectScrollbar>
			</div>
			<button className="app-sidebar-mobile-backdrop" onClick={toggleAppSidebarMobile}></button>
		</React.Fragment>
	);
}

export default Sidebar;